import { borderRadius, colors } from '@/theme'
import type { TimelineFieldChange } from '@/types/timeline'
import ArrowForward from '@mui/icons-material/ArrowForward'
import { Box, Typography } from '@mui/material'

interface TimelineFieldChangesProps {
  changes: TimelineFieldChange[]
}

function renderFieldValue(value: unknown): string {
  if (value == null || value === '') return '[empty]'
  if (typeof value === 'string') return value
  if (typeof value === 'number' || typeof value === 'boolean') return String(value)

  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}

export default function TimelineFieldChanges({ changes }: TimelineFieldChangesProps) {
  if (changes.length === 0) return null

  return (
    <Box sx={{ mt: 2 }}>
      <Typography sx={{ fontSize: '14px', fontWeight: 600, color: colors.text.primary, mb: 1.5 }}>
        Field Changes
      </Typography>

      <Box
        sx={{
          bgcolor: colors.background.surface,
          borderRadius: borderRadius.sm,
          border: `1px solid ${colors.border.default}`,
          overflow: 'hidden'
        }}
      >
        {changes.map(change => (
          <Box
            key={change.field}
            sx={{ p: 2, '&:not(:last-child)': { borderBottom: `1px solid ${colors.border.default}` } }}
          >
            <Typography sx={{ fontSize: '13px', fontWeight: 600, color: colors.text.primary, mb: 1 }}>
              {change.field}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Typography
                component='span'
                sx={{
                  fontSize: '13px',
                  color: colors.text.muted,
                  bgcolor: colors.grey[100],
                  px: 1.5,
                  py: 0.5,
                  borderRadius: borderRadius.xs
                }}
              >
                {renderFieldValue(change.oldValue)}
              </Typography>

              <ArrowForward sx={{ fontSize: 16, color: colors.text.muted }} />

              <Typography component='span' sx={{ fontSize: '13px', color: colors.text.primary, fontWeight: 500 }}>
                {renderFieldValue(change.newValue)}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
